import React from "react"
import {Card, Table, Tag} from "antd"

const GroupBuyingRelation = ({data}) => {


    const columns = [
        {
            title: "团购平台",
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: '状态',
            dataIndex: 'state',
            key: 'state',
            render: (text, record) => (
                <Tag color={record.state ? 'green' : 'blue'}>
                    {record.state ? '已关联' : '未关联'}
                </Tag>
            )
        },
        {
            title: '关联名称',
            dataIndex: 'dealName',
            key: 'dealName',
        },
        {
            title: '价格(元)',
            dataIndex: 'dealAmount',
            key: 'dealAmount',
            render: (text, record) => (
                    record.dealAmount / 100
            )
        }
    ]

    const platforms = [
        {
            id: 1001,
            name: "美团",
            dealName: "无",
            dealAmount: 0,
            state: false
        },
        {
            id: 1002,
            name: "抖音",
            dealName: "无",
            dealAmount: 0,
            state: false
        }
    ]

    platforms.map(item => {
        const platform = data.find(platform => platform.platform.id === item.id)
        if (platform) {
            item.dealName = platform.deal.name
            item.dealAmount = platform.deal.amount
            item.state = true
        }
    })

    return (
        <div>
            <Card
                title={"团购关联"}
            >
                <Table
                    rowKey={record => record.id}
                    columns={columns}
                    dataSource={platforms}
                />
            </Card>
        </div>
    )
}
export default GroupBuyingRelation


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingRelation.js